import { LossePlaatjie } from '@ubo/losse-sjedel'
// import { Fragment } from 'react'
import type { Page_Flexcontent_Flex_Content } from '~/graphql/types'

export default function ContentTitlePlus({ fields }: { fields: Page_Flexcontent_Flex_Content }) {
  return (
    <section data-component="ContentTitlePlus" className="section">
      <div className="container">
        <div className="max-w-[1068px] mx-auto relative">
          <LossePlaatjie className="w-full h-auto object-contain" src={fields.image} />
          {/* <div className="max-w-[640px] relative z-20">
            <h2 className="title--semi-large uppercase !leading-[1.2] text-white">
              {fields.title.split('|').map((t, i) => (
                <Fragment key={i}>
                  <span className="last-of-type:text-site-accent">{t}</span>
                  <br />
                </Fragment>
              ))}
            </h2>
          </div>
          <svg
            className="absolute max-lg:opacity-30 -top-10 lg:top-0 -right-10 lg:right-20"
            width="257"
            height="257"
            viewBox="0 0 257 257"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M155.865 0H101.134V82.0972H155.865V0Z" fill="#78BF00" />
            <path d="M155.865 174.903H101.134V257H155.865V174.903Z" fill="#78BF00" />
            <path d="M257 101.134H174.902V155.866H257V101.134Z" fill="#78BF00" />
            <path d="M82.0972 101.134H0V155.866H82.0972V101.134Z" fill="#78BF00" />
          </svg> */}
        </div>
      </div>
    </section>
  )
}
